import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";

export const booleanFilterTypes: FilterType[] = [
  {
    type: "filter_show_all",
    values: 1,
    applyFunc: () => true,
  },
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: boolean,
      formattedItemValue: any,
      filterValue: boolean
    ) => itemValue === filterValue,
  },
];

export function buildApplyBooleanFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, booleanFilterTypes);
}
